import { format, fromUnixTime } from 'date-fns';

export function formatLastActivity(unixSeconds: number | null): string {
  if (
    unixSeconds == null ||
    !Number.isFinite(unixSeconds) ||
    unixSeconds <= 0
  ) {
    return 'Never';
  }
  return format(fromUnixTime(unixSeconds), 'MMM d, yyyy');
}

export function formatDays(days: number | null): string {
  if (days == null || !Number.isFinite(days) || days < 0) return '—';
  return `${days}d`;
}

export function buildRationale(suggestion: {
  last_activity_t: number | null;
  days_since_last_activity: number | null;
  geofence_age_days: number;
}): string {
  const age = suggestion.geofence_age_days;
  if (suggestion.last_activity_t == null) {
    return `No device has entered or exited this geofence. Created ${age} days ago.`;
  }
  const date = format(fromUnixTime(suggestion.last_activity_t), 'MMM d, yyyy');
  const days = suggestion.days_since_last_activity ?? 0;
  return `No device has entered or exited since ${date} (${days} days). Created ${age} days ago.`;
}
